import { ClientProvider } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface ClientProviderInput {
  name: string;
  cnpj: string;
  address: string;
  state_registration?: string;
  type: number;
  banner?: string;
  phone?: string;
}

export const clientProviderService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<ClientProvider>>(
      "/client_provider",
      {
        params: {
          page,
          per_page,
          search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<ClientProvider, false>>(
      `/client_provider/${id}`,
    );
    return response.data;
  },

  async store(data: ClientProviderInput) {
    const response = await api.post<DefaultResponse<ClientProvider, false>>(
      "/client_provider",
      data,
    );
    return response.data;
  },

  async update(id: number | string, data: ClientProviderInput) {
    const response = await api.put<DefaultResponse<never>>(
      `/client_provider/${id}`,
      data,
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete<DefaultResponse<never>>(
      `/client_provider/${id}`,
    );
    return response.data;
  },
};
